import React from 'react';
import WalletLogo from '../StripeLogo/WalletLogo';

type WalletLoadingMessageProps = {
  type?: string;
};

const WalletLoadingMessage: React.FC<WalletLoadingMessageProps> = ({
  type = '',
}: WalletLoadingMessageProps) => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <div
        style={{
          textAlign: 'center',
          width: '100%',
        }}
      >
        Filling in order details from
      </div>
      <div>
        <WalletLogo stripeWalletType={type} />
      </div>
    </div>
  );
};

export default WalletLoadingMessage;
